import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
import { IconPlacementType } from '../../constant';
import { translate } from '../../../../utils/common';
import GlobalConfig from '../../../../lib/GlobalConfig';
import HeaderConfig from '../../../../constants/header';
import HeaderItemIcon from '../../HeaderItemIcon';
import Image from '../../../common/Image';
import useSharedState from '../../../../hooks/useSharedState';
function getIcon(alt) {
    switch (alt) {
        case 'angle right': {
            return HeaderConfig.ANGLE_RIGHT_ICON_MOBILE;
        }
        case 'angle right blue': {
            return HeaderConfig.ANGLE_RIGHT_ICON_BLUE_MOBILE;
        }
    }
}
const MenuItemDetail = (props) => {
    const { heading, menuItem, lastItem } = props;
    const { name, icon, color, external, linkKey } = menuItem;
    let { url } = menuItem;
    const { state } = useSharedState();
    const menuItemDetailProps = { onClick: null };
    if (linkKey && linkKey === '{{header_live_chat}}') {
        menuItemDetailProps.onClick = () => {
            const liveChatElement = document.getElementById('fresh-chat-custom');
            liveChatElement?.click();
        };
    }
    else if (linkKey && linkKey === '{{youtube_header_link}}') {
        url = GlobalConfig.social.links['youtube'];
    }
    else if (linkKey && linkKey === '{{instagram_header_link}}') {
        url = GlobalConfig.social.links['instagram'];
    }
    return (_jsxs(React.Fragment, { children: [_jsxs("div", { className: clsx((heading && 'iv-mb-30') || (!lastItem && 'iv-pb-25'), icon && 'iv-flex iv-w-full iv-items-center'), children: [icon && !heading && icon.placement === IconPlacementType.PREFIX && (_jsx(HeaderItemIcon, { icon: getIcon(icon.alt), className: 'iv-mr-5' })), (url && (_jsx("a", { href: translate(`url`, { host_url: GlobalConfig.HOST_URL }, { default: url }), className: clsx('iv-block iv-text-body-xl iv-m-body-xl iv-font-medium', color ??
                            'iv-text-grey-50 dark:iv-text-grey-30 dark:hover:iv-text-grey-20 hover:iv-text-black-85'), target: external ? '_blank' : '_self', rel: "noreferrer noopener", children: name }))) || (_jsx("span", { className: clsx('iv-block iv-text-body-xl iv-m-body-xl iv-font-medium', heading
                            ? 'iv-font-semibold iv-text-grey-85 dark:iv-text-grey-15'
                            : color ??
                                'iv-text-grey-50 hover:iv-text-black-85 dark:iv-text-grey-40 dark:hover:iv-text-grey-15', menuItemDetailProps.onClick && 'iv-cursor-pointer'), ...menuItemDetailProps, children: translate(`name`, { siteId: state.siteConfig?.site?.name }, { default: name }) })), icon && !heading && icon.placement === IconPlacementType.SUFFIX && (_jsx(HeaderItemIcon, { icon: getIcon(icon.alt), className: 'iv-ml-5' }))] }), !!menuItem.promo && (_jsx("div", { className: "iv-flex iv-mb-25", children: _jsx(Image, { src: `${GlobalConfig.cdn.SHARED_URL}${menuItem.promo.url}`, alt: menuItem.name, height: 130, width: 198 }) }))] }));
};
export default MenuItemDetail;
